import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MessageBook } from '@model/webFeeder/message-book.model';
import { BilletOrderModalService } from '@services/billet-order-modal.service';
import { AggregatedBookService } from '@services/webFeeder/sckt-aggregated-book.service';
import { AppUtils } from '@utils/app.utils';
import { Subscription , of } from 'rxjs';

@Component({
  selector: 'app-book-aggregated',
  templateUrl: './book-aggregated.component.html'
})
export class BookAggregatedComponent implements OnDestroy, OnChanges {

  @Input() symbol: string;
  @Input() isSubscribeBook: boolean;
  @Input() componentName: string;
  @Input() maxLine = 15;
  private subscriptionAggregatedBook: Subscription;
  loading = false;
  rowPriceData: any[];
  valueBuy: number;
  valueSell: number;
  @Input() tickSize = 2;

  lastMsg: any;

  constructor(
    private _aggregatedBookService: AggregatedBookService,
    private _billetOrderModalService: BilletOrderModalService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.componentName && changes.componentName.currentValue) {
      this.componentName = this.componentName + '{BOOK AGREGADO}';
    }
    if (changes.isSubscribeBook && changes.isSubscribeBook.currentValue && this.symbol) {
      this.subscriptionScktAggregatedBook(this.symbol);
    } else if (changes.isSubscribeBook && !changes.isSubscribeBook.currentValue &&
      changes.symbol.previousValue && changes.symbol.previousValue !== changes.symbol.currentValue) {
      this.unsubscriptionAggregatedBook(changes.symbol.previousValue);
    }
    if (changes.maxLine) {
      this.setRowsValueBook(this.lastMsg);
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptionAggregatedBook) {
      this.unsubscriptionAggregatedBook(this.symbol);
    }
  }

  private subscriptionScktAggregatedBook(symbol: string) {
    this.loading = true;
    this._aggregatedBookService.subscribeAggregatedBook(symbol, this.componentName);
    this.subscriptionAggregatedBook = this._aggregatedBookService.messagesAggregatedBook
      .subscribe((msg: MessageBook) => {
        this.lastMsg = msg;
        if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
          setTimeout(() => {
            this.setRowsValueBook(msg);
          }, 100);
        }
      }, () => {
        this.loading = false;
      });
  }

  setRowsValueBook(msg: MessageBook) {
    this.rowPriceData = [];
    this.valueBuy = 0;
    this.valueSell = 0;
    for (let i = 0; i < this.maxLine; i++) {
      if (msg.buy && msg.buy.length > i) {
        this.valueBuy = this.valueBuy + msg.buy[i].Q;
      }
      if (msg.sell && msg.sell.length > i) {
        this.valueSell = this.valueSell + msg.sell[i].Q;
      }
      let offers = '';
      let qty_purchase = '';
      let purchase = '';
      if (msg.buy && msg.buy.length > i) {
        offers = msg.buy[i].QTD;
        qty_purchase = msg.buy[i].FQ;
        purchase = AppUtils.convertNumberToCurrency(msg.buy[i].P, this.tickSize);
      }
      let sale = '';
      let qty_sale = '';
      let offers2 = '';
      if (msg.sell && msg.sell.length > i) {
        sale = AppUtils.convertNumberToCurrency(msg.sell[i].P, this.tickSize);
        qty_sale = msg.sell[i].FQ;
        offers2 = msg.sell[i].QTD;
      }
      if ((msg.buy && msg.buy.length > i) || (msg.sell && msg.sell.length > i)) {
        this.rowPriceData.push({
          offers: offers,
          qty_purchase: qty_purchase,
          purchase: purchase,
          sale: sale,
          qty_sale: qty_sale,
          offers2: offers2
        });
      }
    }
    this.loading = false;
  }

  private unsubscriptionAggregatedBook(symbol: string) {
    if (this._aggregatedBookService) {
      this._aggregatedBookService.unsubscribeAggregatedBook(symbol, this.componentName);
    }
    if (this.subscriptionAggregatedBook) {
      this.subscriptionAggregatedBook.unsubscribe();
    }
  }

  openBillet(type: string, price: any) {
    if (type === 'buy') {
      this._billetOrderModalService.buySellOrder('buy', this.symbol || '', price || 0.0);
    } else {
      this._billetOrderModalService.buySellOrder('sell', this.symbol || '', price || 0.0);
    }
  }

}
